import { Card, Dialog } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  useTranslate,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import JsonDetailViewer from '../../../components/JsonDetailViewer';
// 导入数据提供者初始化
import './init';

const View = () => {
  const translate = useTranslate();
  const [popup, setPopup] = useState<ReactElement>();
  return (
    <PermissionGuard resource="activity-tier-distribution" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.activityTierBenefits')}
          links={[
            { name: translate('resource.activity') },
            { name: translate('resource.activityTierBenefits') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List resource="adminGetTierDistribution" actions={false} empty={false} exporter={false}>
            <Datagrid rowClick={false}>
              <TextField source="id" label={translate('activity.common.id')} sortable={false} />
              <TextField source="tierLevel" label={translate('activity.tierBenefits.tierLevel')} sortable={false} />
              <TextField source="userCount" label={translate('activity.tierBenefitDistribution.userCount')} sortable={false} />
              <FunctionField
                label={translate('activity.common.detail')}
                render={(record: any) => (
                  <JsonDetailViewer data={record} maxLength={20} label={translate('activity.common.detail')} />
                )}
                sortable={false}
              />
            </Datagrid>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
